/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FeatureFlagsLaunchDarkly({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M8.115 16a.314.314 0 0 1-.308-.334.3.3 0 0 1 .06-.153l3.273-4.529-5.734 2.357a.3.3 0 0 1-.306-.036.3.3 0 0 1-.11-.16.3.3 0 0 1 .13-.338l5.038-2.99-8.874-.513A.303.303 0 0 1 1 8.999a.306.306 0 0 1 .284-.305l8.88-.513-5.043-2.99a.3.3 0 0 1-.126-.338.31.31 0 0 1 .293-.222q.064.001.123.026l5.73 2.358L7.87 2.487a.3.3 0 0 1-.029-.314A.32.32 0 0 1 8.117 2a.3.3 0 0 1 .213.092l6.524 6.555a.5.5 0 0 1 0 .703l-6.527 6.558a.3.3 0 0 1-.212.092" /></svg>;
}
;